export const replaceOrigin = () => {
  const origin = window.location.hostname

  const ret = origin.split(/\./)[0]

  // 本地环境
  if (ret.includes('staticlocal')) {
    return 'https://verify13.eeo.im'
  }

  // www14 => verify14
  const name = ret.replace(/[a-zA-Z]+/g, 'verify')
  return '//' + origin.replace(ret, name)
}

export function isAndroidTablet() {
  const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

  const isAndroid = navigator.userAgent.toLowerCase().indexOf('android') !== -1;
  const isTablet = screenWidth >= 600 && screenHeight >= 600;

  return isAndroid && isTablet;
}
